import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";

function buildUrl(url, token) {
  if (url.includes("mueller") && token) {
    let combiner = (url.includes("?")) ? "&" : "?";
    url = url + combiner + "SSO=" + token;
  }
  return url;
}
/**
 * Link that also works for external URL's
 * src: https://github.com/ReactTraining/react-router/issues/1147
 */
export default function LinkDuo(props) {
  const { to, token } = props;

  // remove the props that won't make sens on the a tag.
  const aProps = Object.assign({}, props);
  delete aProps.token;

  const isAbsoluteUrl = /^[a-z][a-z0-9+.-]*:/.test(to);

  return to && isAbsoluteUrl ?
    <a
      href={buildUrl(to, token)}
      {...aProps}
      target="_blank"
    />
    :
    <Link {...aProps} />;
}

LinkDuo.propTypes = {
  to: PropTypes.string,
  token: PropTypes.string,
  title: PropTypes.string,
};